const $$splitComponentImporter = () => import('/src/src/routes/_anonymous/verify.$token.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_anonymous/verify/$token")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Verify Email Address",
      description: "Page title for the verify email address page path"
    })
  }
});